import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/theme.scss";
import { UserProvider } from "./components/context/UserContext";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import ErrorBoundary from "./components/ErrorBoundary/error";
import axios from "axios";
import { handleLogoutRedux } from "./redux/actions/userAction";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ErrorBoundary>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </ErrorBoundary>
    </PersistGate>
  </Provider>
);
/** Intercept any unauthorized request.
 * dispatch logout action accordingly **/
// const UNAUTHORIZED = 401;
// const { dispatch } = store; // direct access to redux store.
// axios.interceptors.response.use((response) => {
//   console.log("response:", response);
//   const { errorCode } = response;
//   if (errorCode === UNAUTHORIZED) {
//     dispatch(handleLogoutRedux());
//     return Promise.reject(errorCode);
//   }
//   return response.data;
// });
reportWebVitals();
